enum SearchStep {
  Search = 0,
  Result = 1,
}

export default SearchStep